import React, { useState } from "react";
import { EllipsisOutlined } from "@ant-design/icons";
import { Card, Space, Typography } from "antd";
import SendOrderModal from "../forms/sendOrder/fr_SendOrderForm";

import absence from "../../images/jpeg/absence.jpg";
import appointment from "../../images/jpeg/appointment.jpg";
import cash from "../../images/jpeg/cash.jpg";
import suitcase from "../../images/jpeg/suitcase.jpg";
import upcoming from "../../images/jpeg/upcoming.jpg";
import vacation from "../../images/jpeg/vacation.jpg";
import wait from "../../images/jpeg/wait.jpg";
import additions from "../../images/jpeg/additions.PNG";
import deductions from "../../images/jpeg/deductions.PNG";

const CardsScreen = ({ list, showEmpList }) => {
  const [showModal, setShowModal] = useState(false);
  const [orderType, setOrderType] = useState(1);

  const jpegType = (key) => {
    switch (key) {
      case "key_absence":
        return absence;
      case "key_appointment":
        return appointment;
      case "key_cash":
        return cash;
      case "key_suitcase":
        return suitcase;
      case "key_upcoming":
        return upcoming;
      case "key_vacation":
        return vacation;
      case "key_wait":
        return wait;
      case "key_additions":
        return additions;
      case "key_deductions":
        return deductions;
      default:
        return "";
    }
  };

  const fillCards = (list) => {
    if (list?.length > 0) {
      return list.map((e) => {
        return (
          <Card
            bordered={false}
            className="cardHome"
            onClick={async () => {
              await setOrderType(e.type);
              await setShowModal(true);
            }}
            title={
              <label
                style={{
                  fontWeight: 800,
                  fontSize: 12,
                  wordWrap: "break-word",
                }}
              >
                {e?.title}
              </label>
            }
          >
            <a>
              <img
                class="active"
                style={{ width: 75 }}
                alt={e?.key}
                src={jpegType(e?.key)}
              />
            </a>
          </Card>
        );
      });
    }
  };

  return (
    <>
      <SendOrderModal
        showModal={showModal}
        setShowModal={setShowModal}
        orderType={orderType}
        showEmpList={showEmpList}
      />
      <Space wrap size="small">
        {fillCards(list)}
      </Space>
    </>
  );
};
export default CardsScreen;
